import { useContext } from 'react';
import { Box, Select, MenuItem } from '@mui/material';
import {
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
    SettingsBrightness as SystemModeIcon,
} from '@mui/icons-material';

import { ColorModeContext } from './index';

const options = [
    { value: 'light', label: 'Light', icon: <LightModeIcon fontSize='small' /> },
    { value: 'dark', label: 'Dark', icon: <DarkModeIcon fontSize='small' /> },
    { value: 'system', label: 'System', icon: <SystemModeIcon fontSize='small' /> },
];

const ThemeToggle = () => {
    const { preference, setColorMode } = useContext(ColorModeContext);

    return (
        <Select
            value={preference}
            onChange={(e) => setColorMode(e.target.value)}
            size='small'
            variant='outlined'
            renderValue={(value) => {
                const opt = options.find((o) => o.value === value);
                return opt ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        {opt.icon}
                    </Box>
                ) : null;
            }}
            IconComponent={() => null}
            MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                transformOrigin: { vertical: 'top', horizontal: 'right' },
            }}
            sx={(theme) => ({
                minWidth: 36,
                width: 36,
                height: 36,
                borderRadius: 999,
                backgroundColor: theme.palette.background.white,
                color: theme.palette.text.main,
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 !important',
                    paddingRight: '0 !important',
                },
                '& .MuiSvgIcon-root': { color: theme.palette.text.main },
                '& .MuiSelect-icon': { display: 'none' },
                '& fieldset': { display: 'none' },
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                },
            })}
            inputProps={{
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0,
                }
            }}
        >
            {options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {opt.icon}
                        {opt.label}
                    </Box>
                </MenuItem>
            ))}
        </Select>
    );
};

export default ThemeToggle;